import { useQueryClient } from '@tanstack/react-query';
import keys from './keys';
import useApiMutation from '../useApiMutation';

const useSetSpotify = () => {
  const queryClient = useQueryClient();

  const enableSpotify = useApiMutation({
    getRequestUrl: ({ showId } = {}) => `/shows/${showId}/spotify`,
    method: 'POST',
    onSuccess: (newShowData) => {
      queryClient.setQueryData(keys(newShowData.showId).show, newShowData);
    },
  });

  return {
    enableSpotify: enableSpotify.mutate,
    isEnableSpotifyLoading: enableSpotify.isLoading,
    isEnableSpotifyError: enableSpotify.isError,
    isEnableSpotifySuccess: enableSpotify.isSuccess,
    enableSpotifyInfo: { ...enableSpotify },
  };
};

export default useSetSpotify;
